<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ slot: passes }" style="position: absolute;">
      <v-row no-gutters align="center">
        <v-col cols="6" class="pt-8">
          <modal-cadu :close="close" :width="1131.52" v-model="show">
            <div slot="all" class="pt-5 pb-5 px-10">
              <div slot="header">
                <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
                  ADICIONAR MUNICÍPIO
                </div>

                <div slot="body">
                  <v-row>
                    <v-col cols="12" sm="12" md="2" class="pb-0">
                      <validation-provider name="uf" mode="eager" rules="max:2|alpha" v-slot="{ errors }">
                        <autocomplete-cadu
                          title="UF"
                          placeholder=""
                          v-model="uf"
                          :errorMessage="errors[0]"
                          :items="listaUF"
                          :disabled="false"
                          :colorText="fontColor1"
                          @input="inputChangeUF"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="12" md="4" class="pb-0">
                      <validation-provider name="municipio" mode="eager" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Município"
                          placeholder=""
                          v-model="municipio"
                          :items="listaMunicipios.map((el) => el.nome)"
                          :disabled="selectedUF == -1 || uf == null"
                          :colorText="fontColor1"
                          @index="(index) => (indexMunicipioSelecionado = index)"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" sm="12" md="2">
                      <validation-provider name="codigoIBGE" mode="eager" rules="numeric" v-slot="{ errors }">
                        <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Código IBGE"
                          placeholder=""
                          v-model="codigoIBGE"
                          :items="listaCodigoIBGE"
                          :disabled="selectedUF == -1 || uf == null"
                          :colorText="fontColor1"
                        />
                      </validation-provider>
                    </v-col>

                    <v-col cols="auto" class="py-10">
                      <button @click="filtrar()" :disabled="loadingLeft">
                        <icon name="search" :size="18" style="cursor: pointer;" />
                      </button>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" :class="$vuetify.breakpoint.xs ? '' : 'mx-3 container'">
                      <div class="mb-1">Selecione o Munícipio</div>

                      <v-row justify="start">
                        <!-- Lista Municipios  -->
                        <v-col cols="12" sm="12" md="4" class="box" @scroll="onScroll">
                          <div v-if="!loadingLeft">
                            <div class="mx-4">
                              <checkbox-cadu v-model="selAll" :disable="municipiosFiltrados.length <= 0">
                                <div slot="text">Todos os Municípios</div>
                              </checkbox-cadu>
                            </div>

                            <div
                              class="mx-4"
                              v-for="(municipio, index) in municipiosFiltrados"
                              v-show="index < itemsLimit"
                              :key="index"
                            >
                              <checkbox-cadu v-model="checkLeft" @input="selectLeft" :value="municipio.cidade.id">
                                <div slot="text">{{ municipio.cidade.nome }}</div>
                              </checkbox-cadu>
                            </div>
                          </div>

                          <component-loading :value="loadingLeft" />
                        </v-col>

                        <v-col cols="12" sm="12" md="1">
                          <v-row align="center" style="height: 100%;">
                            <v-col cols="12" class="actions">
                              <div align="center" indent="center">
                                <button @click="addMunicipio()">
                                  <icon name="arrow-right-circle" :size="35" style="color: #00995d;" class="mb-3" />
                                </button>
                              </div>

                              <div align="center" indent="center">
                                <button @click="removeMunicipio()">
                                  <icon name="arrow-left-circle" :size="35" style="color: #00995d;" class="mb-3" />
                                </button>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>

                        <!-- Lista Municipio Selecionados  -->
                        <v-col cols="12" sm="12" md="4" class="box">
                          <div v-show="!loadingRight">
                            <div class="mx-4">
                              <checkbox-cadu v-model="remAll" :disable="municipiosSelecionados.length <= 0">
                                <div slot="text">Todos os Municípios</div>
                              </checkbox-cadu>
                            </div>

                            <div class="mx-4" v-for="(municipio, index) in municipiosSelecionados" :key="index">
                              <checkbox-cadu v-model="checkRight" @input="selectRight" :value="municipio.cidade.id">
                                <div slot="text">{{ municipio.cidade.nome }}</div>
                              </checkbox-cadu>
                            </div>
                          </div>

                          <component-loading :value="loadingRight" />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>

                <div slot="footer">
                  <div v-if="!$vuetify.breakpoint.xs">
                    <v-row justify="end" class="linha mt-4">
                      <v-row justify="start">
                        <v-col cols="auto">
                          <button-cadu text="VOLTAR" @click="closeAcao" outline />
                        </v-col>
                      </v-row>
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          text="LIMPAR"
                          @click="limpar()"
                          :backColor="$vuetify.theme.themes.light.primary2"
                        />
                      </v-col>
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          :text="'SALVAR'"
                          @click="finalizar()"
                          class="px-4"
                          :backColor="$vuetify.theme.themes.light.primary1"
                        />
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else>
                    <v-row justify="end" class="linha mt-4">
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          :text="'SALVAR'"
                          @click="finalizar()"
                          block
                          :backColor="$vuetify.theme.themes.light.primary1"
                        />
                      </v-col>
                      <v-col cols="12" sm="auto">
                        <button-cadu
                          text="LIMPAR"
                          block
                          @click="limpar()"
                          :backColor="$vuetify.theme.themes.light.primary2"
                        />
                      </v-col>
                      <v-col cols="12">
                        <button-cadu text="VOLTAR" @click="closeAcao" outline block />
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </modal-cadu>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import { remove, sortedUniqBy, uniqWith, isEqual } from 'lodash'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Estado from '../../../../services/AreaAcao/Estado'
import Municipio from '../../../../services/AreaAcao/Municipio'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      close: true,
      show: this.value,

      selAll: false,
      remAll: false,

      uf: '',
      listaUF: [],
      listaEstados: [],
      selectedUF: -1,

      listaMunicipios: [],
      listaCidades: [],
      municipio: null,

      listaCodigoIBGE: [],
      listaOriginalCodigoIBGE: [],
      codigoIBGE: null,

      municipiosFiltrados: [],
      municipiosSelecionados: [],
      indexMunicipioSelecionado: -1,

      role: '',

      inputEstado: '',

      loadingLeft: false,
      checkLeft: [],
      loadingRight: false,
      checkRight: [],

      itemsLimit: 50,

      fontColor1: this.$vuetify.theme.themes.light.fontColor1
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role

    await this.getEstados()
  },
  methods: {
    async getEstados() {
      this.loadingLeft = true

      const estados = new Estado(this.tokenBearer, this.$appConfig.config.API)

      await estados
        .getEstados()
        .then((res) => {
          const data = res.data

          data.forEach((item) => {
            this.listaUF.push(item.sigla)
            this.listaEstados.push(item)
          })
        })
        .catch(() => {
          this.listaUF = []
          this.listaEstados = []
        })
        .finally(() => (this.loadingLeft = false))
    },
    async getMunicipios(codigo, bool = false) {
      const estado = this.listaEstados.find((estado) => estado.sigla === codigo)

      if (estado) {
        this.selectedUF = estado.id

        const municipio = this.listaMunicipios[this.indexMunicipioSelecionado]
        const municipioNome = this.municipio ? municipio.nome : ''
        const codigoIbge = this.codigoIBGE || ''

        const municipios = new Municipio(
          this.tokenBearer,
          this.$appConfig.config.API,
          this.$idUnimed,
          this.selectedUF,
          municipioNome,
          codigoIbge
        )

        await municipios.getMunicipios().then((res) => {
          const data = res.data

          if (bool) {
            this.listaMunicipios = data
            data.forEach((item) => {
              this.listaCodigoIBGE.push(item.id)
              this.listaOriginalCodigoIBGE = this.listaCodigoIBGE
            })
          }

          this.listaCidades = []
          data.forEach((item) => this.listaCidades.push({ cidade: item }))
        })
      }
    },
    async inputChangeUF(uf) {
      this.inputEstado = uf

      this.municipiosFiltrados = []
      this.listaMunicipios = []
      this.listaCodigoIBGE = []
      this.listaCidades = []

      this.codigoIBGE = ''
      this.municipio = ''

      await this.getMunicipios(this.inputEstado, true)
    },
    async filtrar() {
      let arrSelecionados = []

      this.loadingLeft = true

      this.municipiosFiltrados = []
      this.municipiosSelecionados = []
      this.listaCidades = []

      this.checkLeft = []
      this.checkRight = []

      this.selAll = false
      this.remAll = false

      await this.getMunicipios(this.inputEstado)

      this.municipiosFiltrados = this.listaCidades

      this.municipiosSelecionados.forEach((elSel) => arrSelecionados.push(elSel.cidade.id))

      remove(this.municipiosFiltrados, (el) => arrSelecionados.includes(el.cidade.id))

      this.loadingLeft = false
    },

    addMunicipio() {
      if (this.checkLeft.length == 0) return

      const itemsToRight = sortedUniqBy(
        remove(this.municipiosFiltrados, (el) => this.checkLeft.includes(el.cidade.id)),
        (el) => el.cidade.nome
      )

      this.addItemToList('municipiosSelecionados', itemsToRight)

      this.checkLeft = []
      this.selAll = false
    },
    removeMunicipio() {
      if (this.checkRight.length == 0) return

      const itemsToLeft = sortedUniqBy(
        remove(this.municipiosSelecionados, (el) => this.checkRight.includes(el.cidade.id)),
        (el) => el.cidade.nome
      )

      this.addItemToList('municipiosFiltrados', itemsToLeft)

      this.checkRight = []
      this.remAll = false
    },

    addItemToList(list, items) {
      items = uniqWith(items, isEqual)

      items.forEach((it) => this[list].push(it))

      this[list].sort((a, b) => a.cidade.nome.localeCompare(b.cidade.nome))
    },

    async finalizar() {
      let selecionados = []

      if (this.municipiosSelecionados.length > 0) {
        this.municipiosSelecionados.forEach((municipio) => selecionados.push(municipio.cidade))

        this.$emit('add-municipio', selecionados)
        this.cancelar()
      }
    },

    closeAcao() {
      this.$emit('input', false)
      this.cancelar()
      this.municipiosFiltrados = []
      this.municipiosSelecionados = []
    },

    selectLeft() {
      if (this.checkLeft.length >= this.municipiosFiltrados.length) this.selAll = true
    },
    selectRight(input) {
      this.checkRight = input

      if (this.checkRight.length >= this.municipiosSelecionados.length) this.remAll = true
    },
    onScroll(event) {
      if (this.itemsLimit >= this.municipiosFiltrados) return

      const content = event.target
      const showMoreItems = content.scrollHeight - (content.scrollTop + content.clientHeight) < 100

      if (showMoreItems) {
        this.itemsLimit += 50
      }
    },

    limpar() {
      this.municipio = null
      this.uf = null
      this.codigoIBGE = null

      this.municipiosFiltrados = []
      this.municipiosSelecionados = []
      this.checkLeft = []
      this.checkRight = []
      this.listaCidades = []

      this.selAll = false
      this.remAll = false
    },
    cancelar() {
      this.limpar()
      this.show = false
    }
  },
  watch: {
    municipio() {
      if (this.municipio) {
        this.listaCodigoIBGE = [this.listaOriginalCodigoIBGE[this.indexMunicipioSelecionado]]
      } else if (this.municipio === null) {
        this.listaCodigoIBGE = this.listaOriginalCodigoIBGE
      }
    },
    value() {
      this.show = this.value
    },
    show() {
      if (!this.show) {
        this.closeAcao()
      }
    },
    selAll(status) {
      if (status) {
        this.municipiosFiltrados.forEach((municipio) => this.checkLeft.push(municipio.cidade.id))
      } else this.checkLeft = []
    },
    remAll(status) {
      if (status) {
        this.municipiosSelecionados.forEach((municipio) => this.checkRight.push(municipio.cidade.id))
      } else this.checkRight = []
    }
  }
}
</script>

<style lang="sass" scoped>
.box
    border: 1px solid #9E9E9E
    border-radius: 5px
    height: 300px
    overflow-x: hidden
    overflow-y: visible

::-webkit-scrollbar
    width: 5px

::-webkit-scrollbar-track
    box-shadow: 0 0 5px #DEE2E6
    margin: 15px 5px 6.5px 5px

::-webkit-scrollbar-thumb
    background: #9E9E9E
    height: 100px
</style>
